import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import bemify, { toModifiers } from 'bemify-js';

import { Icon } from '@zapier/design-system';

import { getRef, setRef } from 'app/common/utils/ReactUtils';
import 'app/viewport/components/NotificationBell.scss';

const bem = bemify('notification-bell');

const NotificationBell = createReactClass({
  displayName: 'NotificationBell',
  mixins: [PureRenderMixin],

  propTypes: {
    unreadCount: PropTypes.number.isRequired,
    hasUndelivered: PropTypes.bool.isRequired,
    hasImportant: PropTypes.bool.isRequired,
    onBellRingFinished: PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      hasUndelivered: false,
      hasImportant: false,
    };
  },

  componentDidMount() {
    const { onBellRingFinished } = this.props;
    const bell = getRef(this, 'bell');

    // We only animate when delivering notifications, so if an animation ends,
    // notifications have been delivered. Wait until the animation ends before
    // marking as delivered, otherwise the animation can get cut off with a re-render.
    bell.addEventListener('animationend', onBellRingFinished);
  },

  render() {
    const { unreadCount, hasUndelivered, hasImportant } = this.props;
    const hasUnread = unreadCount > 0;
    const unreadModifier = toModifiers({ unread: hasUnread });
    const animateModifier = toModifiers({ animate: hasUndelivered });
    const delayAnimationModifier = toModifiers({
      animateDelay: hasUndelivered && !hasImportant,
    });

    return (
      <div className={bem()}>
        <div
          className={bem(
            '__icon-container',
            animateModifier,
            delayAnimationModifier
          )}
          ref={setRef(this, 'bell')}
        >
          <span className={bem('__icon', unreadModifier)}>
            <Icon name="navBell" size={24} />
          </span>
        </div>
        {!hasUnread ? null : (
          <div className={bem('__counter', animateModifier)}>{unreadCount}</div>
        )}
      </div>
    );
  },
});

export default NotificationBell;
